/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : userManagementReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 03-07-2024
 * @description Reducer function for handling user-management related actions and state changes.
 */
import actionType from "../actionTypes";

const initialState = {
  error: false,
  msg: "",

  usersList: [],
  rolesList: [],
  rolesListMain: [],
  featuresList: [],
  selectedRoles: [],
  legalStandardDetails: [],
  rolePolicy: [],
};

const emptyOnError = (action) =>
  action.payload.error ? [] : action.payload.data;

const withErrorMsg = (state, action) => ({
  ...state,
  error: action.payload.error,
  msg: action.payload.msg,
});

const withErrorMsgAndData = (state, action, key) => ({
  ...state,
  error: action.payload.error,
  msg: action.payload.msg,
  [key]: emptyOnError(action),
});

const userManagementReducer = (state = initialState, action) => {
  const listKeyByType = {
    [actionType.GET_COUNTRY_CODES]: "countryCodes",
    [actionType.GET_USERS_LIST]: "usersList",
    [actionType.GET_ROLES_LIST]: "rolesList",
    [actionType.GET_FEATURES_LIST]: "featuresList",
  };

  const listKey = listKeyByType[action.type];
  if (listKey) {
    return {
      ...state,
      [listKey]: emptyOnError(action),
    };
  }

  switch (action.type) {
    // case actionType.GET_ROLES_LIST_MAIN:
    //   return {
    //     ...state,
    //     rolesListMain: action.payload.error ? [] : action.payload.data,
    //   };

    //NEW DDH ROLE
    case actionType.ADD_ROLE_DDH_UCM:
    case actionType.PUT_ROLE_DDH_UCM:
    case actionType.DELETE_ROLE_DDH_UCM:
    case actionType.ADD_ROLE_LR_DDH_UCM:
    case actionType.DELETE_ROLE_LR_DDH_UCM:
    case actionType.ADD_ROLE_RP_DDH_UCM:
    case actionType.DELETE_ROLE_RP_DDH_UCM:
      return withErrorMsg(state, action);
    case actionType.LIST_ROLE_DDH_UCM:
      return withErrorMsgAndData(state, action, "rolesListMain");
    case actionType.GET_ROLE_DDH_UCM:
      return withErrorMsgAndData(state, action, "selectedRoles");
    case actionType.GET_ROLE_LR_DDH_UCM:
      return withErrorMsgAndData(state, action, "legalStandardDetails");
    case actionType.GET_ROLE_RP_DDH_UCM:
      return withErrorMsgAndData(state, action, "rolePolicy");
    default:
      return state;
  }
};

export default userManagementReducer;
